import { Component, computed, effect, input } from '@angular/core';
import { FieldTree, FormField } from '@angular/forms/signals';
import { MatInputModule, MatSuffix } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { EngineeringNotation } from '../../../shared/functions/engineering-notation';
import { SystemVoltage, systemVoltageCaseSelect } from './system-voltage.model';

@Component({
  selector: 'cable-edit-system-voltage',
  imports: [FormField,MatSelectModule, MatInputModule, MatSuffix],
  templateUrl: './system-voltage.component.html',
  styles: ``,
})
export class SystemVoltageComponent {

  readonly form = input.required<FieldTree<SystemVoltage>>();
  readonly caseOptions = systemVoltageCaseSelect;

  uToU0 = computed(() => {
    let u = this.form().u().value();
    let u0 = EngineeringNotation.toString(u / Math.sqrt(3), 'V', 1)
    return `[${u0} 1-ph]`
  });


  // Reset fields not visible for the current case to valid defaults
  private _ = effect(() => {
    const currentCase = this.form().case().value();
    const defaults = { v: 100, u0: 230, u: 400, f: 50 };
    if (!this.form().case().dirty()) return;

    switch (currentCase) {
      case 'dc':
        this.form().u0().value.set(defaults.u0);
        this.form().u().value.set(defaults.u);
        this.form().f().value.set(defaults.f);
        break;
      case 'ac1ph':
        this.form().v().value.set(defaults.v);
        this.form().u().value.set(defaults.u);
        break;
      case 'ac3ph':
      case 'tpn':
        this.form().v().value.set(defaults.v);
        this.form().u0().value.set(defaults.u0);
        break;
    }
  });

}
